/* src/app/components/SimpleTable/styles.js */

export default theme => ({
  header: {
    height: theme.spacing.unit * 5,
  },
  gutter: {
    marginBottom: theme.spacing.unit * 4,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/SimpleTable/styles.js